export const isDev = window?.location?.host === 'ltdcfqn.pdfguru.com';
export const BASE_URL = isDev ? 'https://ltdcfqn.pdfguru.com' : 'https://pdfguru.com';

export const PAGE_LINKS = {
  SOCIAL_LinkedIn: 'https://www.linkedin.com/company/pdf-guru',
  SOCIAL_Facebook: 'https://www.facebook.com/pdfguru.converter/',
  SOCIAL_Twitter: 'https://x.com/pdfguru_com',
  SOCIAL_Pinterest: 'https://www.pinterest.com/pdfguruconverter/',
  EXTENSION_LINK: 'https://chromewebstore.google.com/detail/pdf-guru-pdf-converter-ed/lpkcmidikofadbndkgenjamfhlpmncnk',

  // Start SEO pages
  TERMS: `${BASE_URL}/terms`,
  PRIVACY_POLICY: `${BASE_URL}/privacy-policy`,
  MONEY_BACK_POLICY: `${BASE_URL}/money-back-policy`,
  COOKIE_POLICY: `${BASE_URL}/cookie-policy`,
  FAQ_EU: `${BASE_URL}/faq-for-eu-residents`,
  ABOUT_US: `${BASE_URL}/about-us`,
  CONTACT_US: `/app/tools/contact-us`,
  BLOG: `${BASE_URL}/blog`,
  EDIT_SIGN: `${BASE_URL}/edit-and-sign`,
  CONVERT: `${BASE_URL}/conversion-tools`,
  FORMS: `${BASE_URL}/forms`,
  MAIN_SEO: `${BASE_URL}/`,
  FAQ: `${BASE_URL}/faq`,
  SUBSCRIPTION_TERMS: `${BASE_URL}/subscription-terms`,
  // End SEO pages

  MAIN: '/app/tools',
  HOME: '/app/tools',
  LOGIN: '/app/tools/login',
  EDIT_PDF: 'app/tools/edit-pdf',
  COMPRESS_PDF: `/app/tools/compress-pdf`,
  PDF_OCR: '/app/tools/pdf-ocr',
  MERGE_PDF: '/app/tools/merge-pdf',
  MERGE_IMGS: `/app/tools/merge-img`,
  EDITOR: 'app/tools/editor', // for testing skeleton
  DASHBOARD: `app/tools/account`,
  SETTINGS: `app/tools/settings`,
  DASHBOARD_SETTINGS: 'app/tools/account-settings',
  PAYMENT: '/app/tools/payment',
  PAYMENT_SUCCESS: '/app/tools/payment-success',
  NOT_FOUND: '/app/tools/404',
  SIGN_UP: '/app/tools/sign-up',

  PDF_TO_WORD: 'app/tools/pdf-to-word', // for testing skeleton
  PDF_CONVERTOR: `/app/tools/toolspdf-converter`,
  IMAGE_TO_PDF: `/app/tools/image-to-pdf`,
  COMPLETE_MERGE: '/app/tools/complete-merge',
  PDF_CONVERTER: '/app/tools/pdf-converter',
  PDF_TO_EXCEL: `/app/tools/pdf-to-excel`,
  PDF_TO_PPTX: `/app/tools/pdf-to-pptx`,
  SIGNATURE_PDF: `/app/tools/sign-pdf`,
  TRANSLATE_PDF: '/app/tools/translate-pdf',
  IMAGE_TO_TEXT: '/app/tools/image-to-text',
  COMPRESS_IMAGES: '/app/tools/compress-images',
  REMOVE_WATERMARK: '/app/tools/remove-watermark',
  PDF_TO_JPG: '/app/tools/pdf-to-jpg',
  JPG_TO_PDF: '/app/tools/jpg-to-pdf',
  PDF_TO_EPUB: '/app/tools/pdf-to-epub',
  PDF_TO_PNG: '/app/tools/pdf-to-png',
  PNG_TO_PDF: '/app/tools/png-to-pdf',
  WORD_TO_PDF: '/app/tools/word-to-pdf',
  SPLIT_PDF: '/app/tools/split-pdf',
  DELETE_PAGES_FROM_PDF: '/app/tools/delete-pages-from-pdf',

  SEO_LINKS: {
    SUBSCRIPTION_TERMS: `/subscription-terms`,
    TERMS: `/terms`,
    PRIVACY_POLICY: `/privacy-policy`,
    NOTICE: `/privacy-policy#topic_9`,
    MONEY_BACK_POLICY: `/money-back-policy`,
    COOKIE_POLICY: `/cookie-policy`,
    FAQ_EU: `/faq-for-eu-residents`
  }
};
